import ContentLoader from 'react-content-loader';

const AccountSelectorLoader = () => (
  <div className="my-2 flex w-full items-center rounded-lg p-2">
    <ContentLoader
      speed={1}
      width="200px"
      height={200}
      backgroundColor="var(--color-base-200)"
      foregroundColor="var(--color-base-100)">
      <circle cx="18" cy="20" r="18" />
      <rect x="46" y="3" width="148" height="14"></rect>
      <rect x="46" y="23" width="148" height="14"></rect>
    </ContentLoader>
  </div>
);

export default AccountSelectorLoader;
